import { Alert } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdministratorEditForm from '../../components/account/administrators/AdministratorEditForm';
import Loader from '../../components/common/Loader';
import Layout from '../../components/layouts/Layout';
import useAdministratorRequest from '../../requests/AdministratorRequest';
import { AccountRoutes } from '../../routes/AccountRoutes';

const EditAdministrator = ({
  customer,
  accessLevel,
  accessType,
  errorHandler,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getSingleAdministrator } = useAdministratorRequest();
  const getSingleAdministratorRef = useRef(getSingleAdministrator);
  const [administrator, setAdministrator] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      navigate('/account/administrators');
      return;
    }

    let isMounted = true;

    const loadAdministrator = async () => {
      try {
        setIsLoading(true);
        const adminData = await getSingleAdministratorRef.current(
          id,
          errorHandler
        );
        if (isMounted) {
          setAdministrator(adminData);
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error loading administrator:', error);
          setError('Error loading administrator data');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadAdministrator();

    return () => {
      isMounted = false;
    };
  }, [id, navigate]);

  const handleClose = (refresh = false) => {
    navigate('/account/administrators');
  };

  return (
    <Layout
      routes={AccountRoutes}
      title="Edit Administrator"
      backButtonText="Back to Administrator List"
      handleBackButton={handleClose}
      accessLevel={accessLevel}
      accessType={accessType}
      isHidden={!customer.hasCampaign}
    >
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <AdministratorEditForm
          administrator={administrator}
          onClose={handleClose}
          errorHandler={errorHandler}
          accessLevel={accessLevel}
          accessType={accessType}
        />
      )}
    </Layout>
  );
};

export default EditAdministrator;
